// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-layers-container{overflow:hidden;border-radius:6px}.vue-layers-container .solution{position:relative;width:12px;height:20px;pointer-events:none;color:#309b30}.vue-layers-container .solution i{position:absolute;left:-5px;top:-10px}.vue-layers-container .user-answer{position:relative;width:12px;height:20px;pointer-events:none;color:#3434fc}.vue-layers-container .user-answer i{position:absolute;left:-5px;top:-10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
